<template>
  <el-tooltip class="item" effect="dark" :content="tipContent" placement="bottom" :disabled="disabled">
    <div style="">
      <el-button :type="buttonType" :plain="buttonPlain" :size="buttonSize" @click="$emit('click');" :disabled="!disabled"
        v-preventReClick>
        {{ buttonText }}
      </el-button>
    </div>
  </el-tooltip>
</template>
<script>
export default {
  name: 'tooltipButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tipContent: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonSize: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: '',
    },
    buttonPlain: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() { },
  methods: {},
};
</script>
<style scoped>
.item {
  display: inline-block;
  /* float: right; */
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/base/tooltipButton.vue